<template>
  <div
    class="Basket noprint"
    :class="open ? 'Basket__open' : ''"
    v-if="whiteListBasketRoutes($route)"
  >
    <div class="Basket__toggler" @click="open = !open">
      <i
        class="fa fa-caret-left"
        :style="{
          transform: open ? 'rotate(180deg) translate(-24px)' : 'rotate(0deg)'
        }"
      ></i>
    </div>
    <div class="Basket__inside">
      <h3 class="Basket__title">
        <i class="fa fa-folder-open"></i>&nbsp;Classeur
        <span v-if="items.length > 0"
          >({{ items.length }} projet{{ items.length > 1 ? "s" : "" }})</span
        >
      </h3>
      <div class="Basket__items">
        <BasketItem
          :item="item"
          v-for="item in items"
          :key="item.content.uuid"
          @delete="remove(item)"
        />
      </div>
      <div class="Basket__controls">
        <span
          class="pointer has-text-danger"
          :class="!hasItems ? 'dimmed' : ''"
          @click="emptyBasket"
          ><i class="fa fa-folder-minus"></i> Vider le classeur</span
        >
        <span
          class="pointer"
          @click="exportBasket"
          :class="!hasItems ? 'dimmed' : ''"
          ><i class="fa fa-file-export"></i> Exporter</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import BasketItem from "./BasketItem";
import { silence } from "../../util/func";
import { types as basketTypes } from "../../store/actions/basket";
import { types as basketMut } from "../../store/mutations/basket";

/**
 * Note @regnisolbap : ce genre de pattern, c'est justement pour utiliser
 * une fonction avant qu'elle soit implémentée, et ce sans que ESLint/Prettier
 * n'y trouve à redire. "silence" avale l'argument pour éviter un "unused argument",
 * et on renvoie pour le moment "true", ce qui satisfait la signature.
 * @param {VueRouter.Route} _
 * @returns {boolean}
 */
const whiteListBasketRoutes = _ => silence(_) || true;

export default {
  name: "Basket",
  components: { BasketItem },
  computed: {
    items() {
      return this.$store.state.basket;
    },
    open: {
      get() {
        return this.$store.state.basketState;
      },
      set(val) {
        this.$store.commit(
          !val ? basketMut.M_CLOSE_BASKET : basketMut.M_OPEN_BASKET
        );
      }
    },
    hasItems() {
      return this.items.length > 0;
    }
  },
  methods: {
    whiteListBasketRoutes,
    remove({ content: { uuid } }) {
      this.$store.dispatch(basketTypes.REMOVE_BASKET_ITEM, uuid);
    },
    emptyBasket() {
      this.$store.dispatch(basketTypes.CLEAR_BASKET);
    },
    exportBasket() {
      this.$router.push("/export");
      this.open = false;
    }
  }
};
</script>

<style lang="scss">
.Basket {
  position: fixed;
  right: 0;
  width: 320px;
  top: 0;
  height: 100%;
  z-index: 9;
  transform: translate3d(calc(100% - 32px), 0, 0);
  transition: transform 0.5s;
  &__toggler {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 1;
    i {
      transition: transform 0.5s;
    }
  }

  &__inside {
    position: absolute;
    top: 0;
    left: 16px;
    height: 100%;
    width: 100%;
    background: whitesmoke;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 10px #03002888;
    padding: 16px;
  }

  &__open {
    transform: translate3d(0, 0, 0);
  }

  &__items {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% + 16px);
    flex-grow: 1;
    flex: 100%;
    padding-top: 8px;
    padding-right: 16px;
    overflow-y: scroll;
    align-content: flex-start;

    & > div {
      lost-column: 1/2;
      margin-bottom: 8px;
      @lost gutter 8px;
    }
  }

  &__controls {
    padding-right: 16px;
    display: flex;
    margin-top: auto;
    padding-top: 1.2em;
    box-shadow: 0 -8px 10px -8px rgba(0, 0, 0, 0.5);
    position: relative;
    z-index: 1;
    justify-content: space-between;
  }

  &__title {
    padding-bottom: 1.2em;
    box-shadow: 0 8px 10px -10px rgba(0, 0, 0, 0.5);
  }
}
</style>
